<script lang="ts">
  let {
    title,
    message,
    icon
  }: {
    title?: string;
    message?: string;
    icon?: string;
  } = $props();
</script>

<div class="empty-state">
  {#if icon}
    <div class="icon">{icon}</div>
  {/if}
  {#if title}
    <h2>{title}</h2>
  {/if}
  {#if message}
    <p>{message}</p>
  {/if}
</div>

<style lang="scss">
  .empty-state {
    padding: var(--spacing-3xl);
    text-align: center;
    color: var(--color-text-tertiary);

    .icon {
      font-size: 48px;
      margin-bottom: var(--spacing-md);
      opacity: 0.5;
    }

    h2 {
      font-size: var(--font-size-xl);
      font-weight: var(--font-weight-semibold);
      color: var(--color-text-secondary);
      margin: 0 0 var(--spacing-sm);
    }

    p {
      font-size: var(--font-size-base);
      color: var(--color-text-tertiary);
      margin: 0;
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
    }
  }
</style>
